import { dataCustomerSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCustomerSolid = /*#__PURE__*/createIcon(dataCustomerSolid)
export default IconCustomerSolid
